export default forceUppercase

function forceUppercase() {
    return ({
        restrict: 'C',
        require: 'ngModel',
        link(scope, element, attrs, modelCtrl) {
            const capitalize = function (inputValue = '') {
                const capitalized = inputValue.toUpperCase()
                if (capitalized !== inputValue) {
                    modelCtrl.$setViewValue(capitalized)
                    modelCtrl.$render()
                }
                return capitalized
            }

            modelCtrl.$parsers.push(capitalize)
            return capitalize(scope[attrs.ngModel])
        },
    })
}



// WEBPACK FOOTER //
// ./src/directives/forceUppercase/forceUppercase.js